import { type FC, useState } from "react";
import styled from "styled-components";
import {
  LoadingBar,
  Typography,
  TypographyVariant,
} from "../../../../components/ui-kit";
import { AdvancedSearch } from "../../../../components/advanced-search/AdvancedSearch";
import { useModalManager } from "../../../../context/ModalManager";
import api from "../../../../util/api";
import { AdministratorLogDetailModal } from "../../administrators/components/AdministratorLogDetailModal";
import AdministratorLogsTable from "../../administrators/components/AdministratorLogsTable";
import { companyLogsSearchConfig } from "../../administrators/config/logsSearchConfig";
import { LogsFilters } from "../../administrators/hooks/useGetAdministratorLogs";
import { useGetCompanyLogs } from "../hooks/useGetCompanyLogs";

// Same card as the Notes block above it, so the two read as one column.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px 30px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  @media (max-width: 767px) {
    padding: 14px;
  }
`;

const TopLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
`;

const Footnote = styled.div`
  padding-bottom: 12px;
  margin-bottom: 14px;
  border-bottom: 1px solid #eeeeee;
`;

interface CompanyActivityLogSectionProps {
  companyId: string;
}

export const CompanyActivityLogSection: FC<CompanyActivityLogSectionProps> = ({
  companyId,
}) => {
  const { addModal } = useModalManager();
  const [filters, setFilters] = useState<LogsFilters>({});

  const { logs, totalDocs, limit, page, loading, onPaginationChange } =
    useGetCompanyLogs(companyId, filters);

  return (
    <Container>
      <TopLine>
        <Typography variant={TypographyVariant.HEADER2}>
          Activity log
        </Typography>
      </TopLine>
      <Footnote>
        <Typography color="#6C6C8A" variant={TypographyVariant.BODY7}>
          Actions administrators took on this company and its data
        </Typography>
      </Footnote>
      <AdvancedSearch config={companyLogsSearchConfig} onChange={setFilters} />
      <LoadingBar loading={loading} />
      <AdministratorLogsTable
        data={logs}
        contextColumn="administrator"
        onRowClick={(row) =>
          addModal(
            <AdministratorLogDetailModal
              context="company"
              fetchLog={() => api.getCompanyLog(companyId, row._id)}
            />
          )
        }
        pagination={{ page, limit, totalDocs, onPaginationChange }}
      />
    </Container>
  );
};
